import { MultilangString } from '../../types/GlobalTypes';

export const findValueByLang = ({ lang, array }: { lang: string; array: MultilangString[] }) => {
  return array.find(el => el.lang === lang)?.value;
};
